export default function getChallenge(state) {
  if (state.loginForm && state.loginForm.challenge) {
    return state.loginForm.challenge;
  }
}